import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import i18n from 'i18next';
import { styleMerge, getStyle, SERVICE_WORKSHOP, SERVICE_FLEET, SERVICE_CHAIN, TYPE_CARE_SERVICE, TYPE_CHAIN_CARE_SERVICE, TYPE_WORKSHOP_ALL, getCurrentCompany } from '../../utils/utils';
import CBMediaQuery from './CBMediaQuery';
import {
  searchMaintenances as _searchMaintenances,
  searchTreatments as _searchTreatments,
} from '../../actions/searchActions';
import CBSelectField from './form_components/CBSelectField';
import CBButtonAddCar from './CBButtonAddCar';
import CBSearchInput from './CBSearchInput';
import CBSelect from './CBSelect';
import CBSelectFilters from './CBSelectFilters';
import CBButtonGarageAction from './CBButtonGarageAction';
import { fetchOrganizations as _fetchOrganizations } from '../../actions/organizationActions';
import { fetchChainCareServices as _fetchChainCareServices } from '../../actions/chainActions';
import CBLabelAndCheckbox from './CBLabelAndCheckbox';

class VehicleFilterBar extends Component {
  componentWillMount() {
    const {
      fetchOrganizations,
      fetchChainCareServices,
      service,
      selectedWorkshopId,
      selectedChainId,
    } = this.props;

    if (service === SERVICE_WORKSHOP) {
      fetchOrganizations({ workshop_id: selectedWorkshopId });
    }
    if (service === SERVICE_CHAIN && selectedChainId) {
      fetchChainCareServices(selectedChainId);
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedWorkshopId, fetchOrganizations, selectedChainId, fetchChainCareServices, service } = this.props;

    if (selectedWorkshopId != prevProps.selectedWorkshopId) {
      fetchOrganizations({ workshop_id: selectedWorkshopId });
    }
    if (service === SERVICE_CHAIN && selectedChainId && selectedChainId != prevProps.selectedChainId) {
      fetchChainCareServices(selectedChainId);
    }
  };

  getOrganizationOptions = () => {
    const { organizations } = this.props;

    const options = organizations.map((org) => {
      return {
        value: org.id,
        label: org.name,
      }
    });

    options.unshift({
      label: this.props.t('allCompanies'),
      value: '',
    });

    return options;
  }

  getChainCustomerOptions = () => {
    const { chainCareServices, t } = this.props;

    const options = [
      { value: '', label: t('allCustomers') },
    ];
    const seen = {};

    if (chainCareServices && chainCareServices.length > 0) {
      chainCareServices.forEach((cs) => {
        const orgId = cs.organization;
        if (orgId && !seen[orgId]) {
          seen[orgId] = true;
          options.push({
            value: String(orgId),
            label: cs.organization_name || '-',
          });
        }
      });
    }

    return options;
  }

  // CBSelectFilters reports only its own key. Merge it into the filters already
  // in force so the pickers don't wipe each other; an empty value clears just
  // the one that changed.
  applyFilterChange = (changed) => {
    const { filters, changeFilterTerms } = this.props;
    const newFilters = { ...filters };

    Object.keys(changed).forEach((key) => {
      if (changed[key]) {
        newFilters[key] = changed[key];
      } else {
        delete newFilters[key];
      }
    });

    changeFilterTerms(newFilters);
  }

  getBusinessUnitOptions = () => {
    const { businessUnitChoices, t } = this.props;
    const choices = businessUnitChoices || [];

    // A workshop's or chain's list spans several customers, two of which may
    // both have a "Helsinki" — name the company only where it disambiguates.
    const nameCounts = {};
    choices.forEach((choice) => {
      nameCounts[choice.name] = (nameCounts[choice.name] || 0) + 1;
    });

    return [{ value: '', label: t('allBusinessUnits') }].concat(
      choices.map((choice) => ({
        value: String(choice.id),
        label: nameCounts[choice.name] > 1 && choice.organization_name
          ? `${choice.name} (${choice.organization_name})`
          : choice.name,
      }))
    );
  }

  getCheckListItemChoices = () => {
    const { checkListItemChoices } = this.props;

    const uniqueChoices = [];
    const options = checkListItemChoices.reduce((acc, item) => {
      if (!uniqueChoices.includes(item.name)) {
        uniqueChoices.push(item.name);
        acc.push({
          value: item.name,
          label: item.name,
        });
      }
      return acc;
    }, []);

    options.unshift({
      label: this.props.t('allInspections'),
      value: '',
    });

    return options;
  }

  render() {
    const {
      addCar,
      inviteToCareService,
      addWSVehicle,
      t,
      changeSearchTerms,
      refetchVehicles,
      service,
      user,
      selectedOrganizationId,
      filters,
      changeFilterTerms,
      listType,
      useIdentifiers,
      search,
      selectedWorkshopId,
      businessUnitChoices,
    } = this.props;

    const currentOrganization = getCurrentCompany(user, selectedOrganizationId, null, null);
    const userWorkshops = user && user.workshops;
    const selectedWorkshop = userWorkshops && userWorkshops.find(w => w.id == selectedWorkshopId);
    const workshopBelongsToChain = selectedWorkshop && selectedWorkshop.belongs_to_chain;

    const addCarDisabled = service === SERVICE_FLEET && currentOrganization && !currentOrganization.paid_subscription;

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'containerFilters')}>
              <div style={getStyle(screenSize, styles, 'containerSearch')}>
                <CBSearchInput
                  containerStyle={{ height: 40, width: 200, marginLeft: 0 , marginRight: 0}}
                  changeSearchTerms={changeSearchTerms}
                  onBlur={refetchVehicles}
                  value={search}
                />
                {
                  useIdentifiers && (
                    <CBLabelAndCheckbox
                      labelText={t('searchIdentifiersOnly')}
                      checked={filters.search_identifiers}
                      onChange={
                        () => {
                          const newFilters = {...filters};
                          if (!filters.search_identifiers) {
                            return changeFilterTerms({...newFilters, search_identifiers: true })
                          } else {
                            delete newFilters.search_identifiers;
                            return changeFilterTerms({...newFilters})
                          }
                        }
                      }
                    />
                  )
                }
              </div>
              {
                service === SERVICE_WORKSHOP && listType === TYPE_CARE_SERVICE && (
                 <div style={getStyle(screenSize, styles, 'selectFiltersContainer')}>
                  <CBSelectFilters
                    name='organization'
                    options={this.getOrganizationOptions()}
                    onChange={this.applyFilterChange}
                    value={filters.organization}
                    selectStyle={{marginLeft: 0, marginRight: 0}}
                  />
                  </div>
                )
              }
              {
                service === SERVICE_CHAIN && listType === TYPE_CHAIN_CARE_SERVICE && (
                 <div style={getStyle(screenSize, styles, 'selectFiltersContainer')}>
                  <CBSelectFilters
                    name='organization_id'
                    options={this.getChainCustomerOptions()}
                    onChange={this.applyFilterChange}
                    value={filters.organization_id || ''}
                    selectStyle={{marginLeft: 0, marginRight: 0}}
                  />
                  </div>
                )
              }

              {
                businessUnitChoices && businessUnitChoices.length > 0 && (
                  <div style={getStyle(screenSize, styles, 'selectFiltersContainer')}>
                    <CBSelectFilters
                      name='business_unit'
                      options={this.getBusinessUnitOptions()}
                      onChange={this.applyFilterChange}
                      value={filters.business_unit || ''}
                      selectStyle={{marginLeft: 0, marginRight: 0, width: 200}}
                    />
                  </div>
                )
              }

              <div style={getStyle(screenSize, styles, 'selectFiltersContainer')}>
                <CBSelectFilters
                  name='filter_next_check'
                  options={this.getCheckListItemChoices()}
                  onChange={this.applyFilterChange}
                  value={filters.filter_next_check}
                  selectStyle={{marginLeft: 0, marginRight: 0, width: 200}}
                />
              </div>

              {
                service === SERVICE_WORKSHOP && listType === TYPE_CARE_SERVICE && workshopBelongsToChain && (
                  <CBLabelAndCheckbox
                    labelText={t('showChainCareServiceVehicles')}
                    checked={filters.include_chain_vehicles !== false}
                    onChange={
                      () => {
                        const newFilters = {...filters};
                        if (filters.include_chain_vehicles === false) {
                          delete newFilters.include_chain_vehicles;
                          return changeFilterTerms({...newFilters});
                        }
                        return changeFilterTerms({...newFilters, include_chain_vehicles: false });
                      }
                    }
                  />
                )
              }

              {
                service === SERVICE_WORKSHOP && listType === TYPE_CARE_SERVICE && selectedWorkshop && selectedWorkshop.workshop_chains && selectedWorkshop.workshop_chains.length > 1 && filters.include_chain_vehicles !== false && (
                  <CBSelectFilters
                    name='chain_id'
                    options={[{ value: '', label: t('filterAllChains') }].concat(
                      selectedWorkshop.workshop_chains.map(function (c) { return { value: String(c.id), label: c.name }; })
                    )}
                    onChange={function (changed) {
                      var onChainChange = this.props.onChainFilterChange;
                      if (onChainChange) {
                        onChainChange(changed.chain_id ? parseInt(changed.chain_id) : null);
                      }
                    }.bind(this)}
                    value={this.props.selectedWorkshopChainId ? String(this.props.selectedWorkshopChainId) : ''}
                    selectStyle={{ marginLeft: 0, marginRight: 0, width: 200 }}
                  />
                )
              }

            </div>
            <div style={getStyle(screenSize, styles, 'containerActions')}>
              {
                ((service === SERVICE_WORKSHOP && listType === TYPE_CARE_SERVICE) || (service === SERVICE_CHAIN && listType === TYPE_CHAIN_CARE_SERVICE)) && (
                  <CBButtonGarageAction
                    onClick={inviteToCareService}
                    text={t('inviteToCareService')}
                    mainIcon='/img/icon_care_service.svg'
                    containerStyle={{marginLeft: 10, marginRight: 10}}
                  />
                )
              }
              {
                listType === TYPE_WORKSHOP_ALL && (
                  <CBButtonGarageAction
                    onClick={addWSVehicle}
                    text={t('addWSVehicle')}
                    additionalIcon='/img/icon_plus.svg'
                    mainIcon='/img/icon_car_basic_info.svg'
                  />
                )
              }
              {
                listType !== TYPE_WORKSHOP_ALL && (service === SERVICE_WORKSHOP || service === SERVICE_CHAIN || (currentOrganization && currentOrganization.id != 'all')) && (
                  <div style={getStyle(screenSize, styles, 'addCarContainer')}>
                    <CBButtonGarageAction
                      onClick={addCar}
                      text={t('addCarOrganization')}
                      additionalIcon='/img/icon_plus.svg'
                      mainIcon='/img/icon_car_basic_info.svg'
                      disabled={addCarDisabled}
                    />
                    {
                      addCarDisabled && (
                        <div  style={getStyle(screenSize, styles, 'addCarInfoTextContainer')}>
                          <p>{t('subscriptionRequired')}</p>
                          <p>{t('contactForSubscription')}</p>
                        </div>
                      )
                    }
                  </div>
                )
              }
            </div>

          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    containerSearch: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    containerFilters: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: 12,
    },
    addCarContainer: {
      fontSize: 12,
    },
    addCarInfoTextContainer: {
      marginTop: 8,
    },
    containerActions: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    selectFiltersContainer: {
      maxWidth: 240
    },
  }
};

function mapStateToProps(state) {
  return {
    searchRequest: state.search,
    service: state.app.service,
    user: state.authUser.user,
    selectedOrganizationId: state.organization.selectedOrganization,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedChainId: state.chain.selectedChainId,
    organizations: state.organization.organizations,
    chainCareServices: state.chain.chainCareServices
  };
}

export default connect(
  mapStateToProps,
  {
    fetchOrganizations: _fetchOrganizations,
    fetchChainCareServices: _fetchChainCareServices
  },
)(translate('VehicleListView')(VehicleFilterBar));
